(() => {
  'use strict';

  const STYLE_ID = 'FafPdpStickyVisibilityStyles';
  const DESKTOP_QUERY = '(min-width: 1024px)';

  function installStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      [data-pdp-sticky].faf-pdp-sticky-force-show { display: block !important; }
      [data-pdp-sticky].faf-pdp-sticky-force-hide { display: none !important; }
    `;
    document.head.appendChild(style);
  }

  function readConfig() {
    const configElement = document.querySelector('[id^="PdpConfig-"]');
    if (!configElement) return {};

    try {
      return JSON.parse(configElement.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function getStickyOffset(desktop) {
    const measurement = window.FAFHeaderOffset?.current;
    const measured = Number(desktop ? measurement?.desktopTop : measurement?.mobileTop);

    if (Number.isFinite(measured) && measured >= 0) return measured;

    const styles = getComputedStyle(document.documentElement);
    const componentProperty = desktop ? '--desktop-menu-offset' : '--mobile-menu-offset';
    const componentOffset = Number.parseFloat(styles.getPropertyValue(componentProperty));

    if (Number.isFinite(componentOffset) && componentOffset >= 0) return componentOffset;

    const siteOffset = Number.parseFloat(styles.getPropertyValue('--site-header-offset'));
    if (Number.isFinite(siteOffset) && siteOffset >= 0) return siteOffset;

    return desktop ? 70 : 66;
  }

  function install() {
    const sticky = document.querySelector('[data-pdp-sticky]');
    const sentinel = document.querySelector('[data-native-atc-sentinel]');

    if (!sticky || !sentinel || sticky.dataset.fafVisibilityReady === 'true') return false;

    installStyles();
    sticky.dataset.fafVisibilityReady = 'true';

    const mediaQuery = window.matchMedia(DESKTOP_QUERY);
    const config = readConfig();
    let variantId = String(config.initialVariantId || '');
    let available = variantId
      ? config.initialAvailable === true || config.initialAvailable === 'true'
      : true;
    let frame = 0;

    const update = () => {
      frame = 0;

      const rect = sentinel.getBoundingClientRect();
      const desktop = mediaQuery.matches;
      const stickyOffset = getStickyOffset(desktop);
      const viewportHeight = Number(window.visualViewport?.height || window.innerHeight || document.documentElement.clientHeight || 0);

      // Desktop: show once the native ATB has passed beneath the sticky header.
      // Mobile: show only while the native ATB is still below the viewport;
      // hide as soon as it enters view and keep it hidden after the customer passes it.
      const positionVisible = desktop
        ? rect.bottom <= stickyOffset
        : rect.top >= viewportHeight;

      const shouldShow = positionVisible && (!variantId || available);

      sticky.classList.toggle('faf-pdp-sticky-force-show', shouldShow);
      sticky.classList.toggle('faf-pdp-sticky-force-hide', !shouldShow);
    };

    const schedule = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('faf:header-offset-change', schedule);
    window.addEventListener('variant-change', (event) => {
      const detail = event.detail || {};

      if (config.productId && detail.productId && String(detail.productId) !== String(config.productId)) return;

      variantId = detail.variantId ? String(detail.variantId) : '';
      available = variantId
        ? detail.available === true || detail.available === 'true'
        : true;
      schedule();
    });

    if (mediaQuery.addEventListener) mediaQuery.addEventListener('change', schedule);
    else mediaQuery.addListener(schedule);

    schedule();
    return true;
  }

  function boot() {
    if (install()) return;
    window.requestAnimationFrame(install);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
